// @flow
import React, {
    createContext,
    useState,
    useContext,
    useCallback,
    useMemo,
} from 'react';

type Props = {
    children: React$Element<any>,
};

const OrderNoteContext = createContext({
    isNoteEditing: false,
    openNoteEditor: () => {},
    closeNoteEditor: () => {},
    canShowAddNoteButton: false,
    hideAddNoteButton: () => {},
    showAddNoteButton: () => {},
});

const OrderNoteProvider = ({ children }: Props): React$Element<any> => {
    const [isNoteEditing, setIsNoteEditing] = useState(false);
    const [canShowAddNoteButton, setCanShowAddNoteButton] = useState(false);

    const openNoteEditor = useCallback(() => setIsNoteEditing(true), []);
    const closeNoteEditor = useCallback(() => setIsNoteEditing(false), []);

    const showAddNoteButton = useCallback(
        () => setCanShowAddNoteButton(true),
        []
    );
    const hideAddNoteButton = useCallback(
        () => setCanShowAddNoteButton(false),
        []
    );

    const value = useMemo(
        () => ({
            isNoteEditing,
            openNoteEditor,
            closeNoteEditor,
            canShowAddNoteButton,
            hideAddNoteButton,
            showAddNoteButton,
        }),
        [
            isNoteEditing,
            openNoteEditor,
            closeNoteEditor,
            canShowAddNoteButton,
            hideAddNoteButton,
            showAddNoteButton,
        ]
    );

    return (
        <OrderNoteContext.Provider value={value}>
            {children}
        </OrderNoteContext.Provider>
    );
};

const useOrderNoteContext = (): any => {
    const context = useContext(OrderNoteContext);
    return context;
};

export { useOrderNoteContext, OrderNoteProvider };
